<template>
  <div class="menu-categories-editor main">
    <div class="wrapper">
      <!-- <button class="delete is-large" @click="close" /> -->
      <p class="subtitle">
        <i
          class="fa fa-chevron-left"
          style="padding-right: 4px"
          @click="close"
        />
        Categories Editor
      </p>

      <p
        class="button is-primary is-fullwidth"
        style="margin-bottom: 6px"
        @click="sortMenuItems"
      >
        Sort menu items by category&nbsp;<i class="fa fa-chevron-right fa-lg" />
      </p>

      <p style="margin-bottom: 2px">
        <i class="button is-white pl-0 hint">Drag to re-order</i>
      </p>
      <div class="list no-scrollbar" :key="z">
        <draggable
          v-model="catArray"
          handle=".handle"
          @start="drag = true"
          @end="drag = false"
          @change="dragged"
        >
          <div v-for="c in catArray" :key="c.name" class="list-item">
            <span class="item-name">{{ c.name }}</span>
            <span class="is-pulled-right">
              <span class="tag is-rounded handle">
                <i class="fa fa-grip-lines fa-lg" style="padding: 0 6px" />
              </span>
            </span>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "MenuCategoriesEditor",
  components: {
    draggable,
  },
  props: {
    categories: Array,
  },
  data() {
    return {
      catArray: [], // copy of props categories
      contentLang: "en", // default English
      z: 0,
    };
  },
  computed: {},
  mounted() {
    this.catArray = this.categories;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    sortMenuItems() {
      this.$emit("sort");
      this.close();
    },
    dragged() {
      console.log("dragged", this.catArray);
      this.$emit("reorder", this.catArray);
    },
    deleteOptionsMenu() {
      if (!this.m) {
        this.close(); // if not saved to DB yet then just close
        return;
      }
      var red = this.bulmaColor("danger");
      this.$swal({
        title: `<i class="fa fa-bomb" style="color: ${red}" />`,
        html: `Are you sure you want to soft delete this options menu?`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: this.$t("cancel"),
        confirmButtonColor: red,
      }).then((val) => {
        if (val.value) {
          var loader = this.loadingDots("blue");
          this.$store
            .dispatch("deleteBlob", this.m.id)
            .then(() => {
              this.infoToast("Options menu deleted!", "top");
              this.$emit("update", null);
              this.close();
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },

    init() {
      if (!this.m) return;
      this.name = this.m.data.name;
      this.select = this.m.data.select;
      this.required = this.m.data.required;
      this.items = this.m.data.items;
      this.languages.forEach((l) => {
        this.names[l] = this.m.data[l];
      });
      this.setContentLang("en", true);
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  /* background-color: rgba(255, 255, 255, 0.95); */
  background-color: white;
  z-index: 21;
  /* backdrop-filter: blur(3px); */
  text-align: left;
}
.wrapper {
  padding: 16px;
}
.subtitle {
  text-align: left;
  font-weight: 500;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
}
.notification {
  padding: 10px;
}
.menu {
  overflow: scroll;
  max-height: calc(100vh - 230px);
}
.hint {
  font-weight: 500;
  opacity: 0.5;
}
.item {
  /* box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2); */
  margin-bottom: 10px;
}
.list-item {
  text-align: left;
}
.pl-0 {
  padding-left: 0;
}
.list {
  max-height: calc(100vh - 164px);
  overflow: scroll;
  margin-bottom: 10px;
}
.item-name {
  font-size: 1.2em;
  display: inline-block;
  max-width: calc(100vw - 115px);
}
</style>